import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';

import { PoliticianService } from '../../services/politician.service';
import { LegislatureService } from '../../services/legislature.service';
import { GovernmentService } from '../../services/government.service';
import { UserService } from '../../services/user.service';
import { ClientService } from '../../services/client.service';
import { OrganizationService } from '../../services/organization.service';
import { ToastComponent } from '../toast/toast.component';
import { ee } from '../constants';
import { removeTooltipElement } from '../functions';
import { SearchInputModel } from '../types';
import { fromEvent } from 'rxjs';
import { debounceTime, finalize, map } from 'rxjs/operators';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  standalone: false
})
export class SearchInputComponent implements OnInit, AfterViewInit {
  private politicianService = inject(PoliticianService);
  private legislatureService = inject(LegislatureService);
  private governmentService = inject(GovernmentService);
  private userService = inject(UserService);
  private clientService = inject(ClientService);
  private organizationService = inject(OrganizationService);
  toast = inject(ToastComponent);


  @Input() model: SearchInputModel;
  @Input() items = [];
  @Input() placeholder = 'Last name';
  @ViewChild('searchInput') searchInput: ElementRef;

  isLoading = false;
  itemsIds = [];
  itemsFound = [];
  hideMenu = true;

  ngOnInit(): void {
    this.itemsIds = this.items.map(item => item._id);
  }

  ngAfterViewInit(): void {
    this.searchEvent();
  }

  searchEvent(): void {
    this.itemsFound = [];
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(
        map((event: any) => event.target.value),
        debounceTime(400),
      )
      .subscribe({
        next: (text: string) => {
          this.isLoading = true;
          this.itemsFound = [];
          if (text) {
            this.findItem(text);
          } else {
            this.isLoading = false;
            this.itemsFound = [];
          }
        }
      });
  }

  getParams(model: SearchInputModel, text: string) {
    const criteria = {
      user: { lastName: text, disabled: '0', projectionFields: 'firstName,lastName' },
      politician: { lastName: text, projectionFields: 'firstName,lastName,organ' },
      client: { name: text, active: '1', projectionFields: 'name' },
      organization: { name: text, projectionFields: 'name' },
      legislature: { name: text, projectionFields: 'name' },
      government: { name: text, projectionFields: 'name' },
    };
    return criteria[model];
  }

  findItem(text: string): void {
    const service = {
      politician: this.politicianService,
      user: this.userService,
      client: this.clientService,
      organization: this.organizationService,
      legislature: this.legislatureService,
      government: this.governmentService,
    };
    const params = this.getParams(this.model, text);
    service[this.model].search({ ...params, perPage: 10 })
      .pipe(finalize(() => {
        this.hideMenu = false;
        this.isLoading = false;
      }))
      .subscribe({
        next: res => this.itemsFound = res.results || [],
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  selectItem(item: any): void {
    const found = this.items.find(elem => elem._id === item._id);
    // Prevent to push same item multiple times
    if (!found) {
      this.items.push(item);
      this.itemsIds = this.items.map(elem => elem._id);
      this.emitIds();
    }
    this.hideMenu = true;
    this.searchInput.nativeElement.value = '';
  }

  removeSelectedItem(item: any): void {
    this.itemsIds = this.items.map(elem => elem._id);
    const idx = this.itemsIds.indexOf(item._id);
    this.items.splice(idx, 1);
    this.itemsIds.splice(idx, 1);
    this.emitIds();
    removeTooltipElement();
  }

  emitIds(): void {
    const key = `_${this.model}s`; // user -> _users
    ee.emit('searchInput', { [key]: this.itemsIds });
  }

}
